import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { style } from "@vanilla-extract/css";

export const ANALYSIS_INDEX_BREAKPOINT = 700;

export const gridStyle = style({
  gap: `${theme.spacings.xl} ${theme.spacings.l} !important`,
  gridTemplateColumns: "repeat(1, 1fr)",
  ...responsiveContainer({
    [ANALYSIS_INDEX_BREAKPOINT]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  }),
});
